module.exports = __webpack_public_path__ + "img/bg-mobile.5286782a.jpg";